import { IonIcon, IonItem, useIonViewDidLeave, useIonViewWillEnter } from '@ionic/react';
import React from 'react';
import Page from '../../../components/Page';
import { EnvironmentConfig, getFlag } from '../../../utils/environmentUtils';
import { useTranslation } from 'react-i18next';
import { closeOutline, ellipse } from 'ionicons/icons';
import { atom, useRecoilState } from 'recoil';

interface IntegrationsTabsPageProps {
  children: any;
  tab: string;
}

export const integrationLocationAlertState = atom<boolean | null>({
  key: 'integrationLocationAlertState',
  default: null,
});

const IntegrationsTabsPage: React.FC<IntegrationsTabsPageProps> = ({ children, tab }) => {
  const [showLocationsAlert, setShowLocationAlert] = useRecoilState(integrationLocationAlertState);
  const { t } = useTranslation();

  useIonViewWillEnter(() => {
    const showLocationAlertFlag = localStorage.getItem('showLocationAlertFlag');
    if (!showLocationAlertFlag) {
      localStorage.setItem('showLocationAlertFlag', JSON.stringify(true));
      setShowLocationAlert(true);
    }

    if (showLocationAlertFlag) {
      const flagValue = JSON.parse(showLocationAlertFlag);
      setShowLocationAlert(flagValue);
    }
  }, []);

  useIonViewDidLeave(() => {
    if (tab === 'locations') {
      setShowLocationAlert(false);
      localStorage.setItem('showLocationAlertFlag', JSON.stringify(false));
    }
  }, [tab]);

  const title = t('title.integrations.qm');

  return (
    <Page title={title}>
      {getFlag(EnvironmentConfig.SHOW_INTEGRATION_LINKING) ? (
        <>
          <div className="d-flex ion-justify-content-start ion-margin-bottom">
            <IonItem
              className={`ion-no-padding ion-text-center people-page ${
                tab === 'settings' ? 'item-active font-weight-600' : ''
              }`}
              routerLink="/linkQM/settings"
              routerDirection="none"
            >
              Settings
            </IonItem>
            <IonItem
              className={`ion-no-padding ion-text-center people-page d-flex ion-align-items-center ${
                tab === 'locations' ? 'item-active font-weight-600' : ''
              }`}
              routerLink="/linkQM/locations"
              routerDirection="none"
            >
              Locations
              {showLocationsAlert && (
                <IonIcon icon={ellipse} style={{ color: '#0032B2', fontSize: '1.125rem', marginLeft: '.5rem' }} />
              )}
            </IonItem>
          </div>
          {tab === 'locations' && showLocationsAlert && (
            <div
              className="d-flex ion-justify-content-between ion-align-items-center"
              style={{
                background: '#D9F1FE',
                color: '#0032B2',
                border: '1px solid #0032B2',
                padding: '1rem',
                borderRadius: '4px',
                maxWidth: 'fit-content',
                gap: '16px',
              }}
            >
              <IonIcon icon={ellipse} />
              <div className="d-flex ion-align-items-ceter">
                <div className="d-flex ion-align-items-center">
                  <strong style={{ marginRight: '.5rem' }}>Info:</strong>
                  <span>Turn each location to </span>
                  <div
                    style={{
                      background: 'var(--ion-color-primary)',
                      color: 'white',
                      padding: '.25rem .5rem',
                      margin: '0 .5rem',
                      pointerEvents: 'none',
                    }}
                  >
                    On
                  </div>
                  <span> below for deficiency checklists to be auto-generated there.</span>
                </div>
              </div>
              <IonIcon
                className="font-32 clickable"
                icon={closeOutline}
                onClick={() => {
                  setShowLocationAlert(false);
                  localStorage.setItem('showLocationAlertFlag', JSON.stringify(false));
                }}
              />
            </div>
          )}
        </>
      ) : null}
      {children}
    </Page>
  );
};

export default IntegrationsTabsPage;
